<template>
  <div id="app" class="bg" :class="bgClass">
    <router-view />
  </div>
</template>

<script>
import version from '@/version/version.json'
export default {
  name: '',
  data () {
    return {
      bgClass: '',
      bgConfigs: [
        {
          path: '/login',
          bgClass: 'bg-login'
        },
      ]
    }
  },
  watch: {
    $route: {
      handler: function (nv) {
        this.bgClass = ''
        this.bgConfigs.forEach((config) => {
          if (config.path.includes(nv.path)) {
            this.bgClass = config.bgClass
            // this.$forceUpdate();
          }
        })
      },
      immediate: true
    }
  },
  mounted () {
    console.log(version)
  }
}
</script>

<style lang="less">
@import url("assets/css/variable.css");
@import url("assets/css/init.css");
@import url("assets/css/index.less");
// @import url("assets/css/ElementPlus.css");
@import url("assets/css/ElementPlus.less");
@import url("assets/css/customer.less");
@import url("assets/css/font-awesome.min.css");
@import url("App.less");
@import url("assets/css/control.less");

#app {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: 0 0;
}

.bg-login {
  background-image: url("/static/img/login-bg1.jpeg");
}
</style>
